import { Box, CircularProgress, makeStyles } from '@material-ui/core';
import {
  colors,
  DefaultButton,
  SubTitle2Text,
  SubTitle3Text,
} from 'design-system';
// Hooks
import useDownloadPolicy from 'src/hooks/useDownloadPolicy';
// models
import { EmissionResume } from 'src/models/emission/EmissionResume';
// Redux
import { connect, ConnectedProps } from 'react-redux';
import { RootState } from 'src/store/rootReducer';

const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    flexGrow: 1,
    flexFlow: 'column',
  },
  content: {
    display: 'flex',
    flexGrow: 1,
    overflowY: 'auto',
    flexFlow: 'column',
    justifyContent: 'center',
  },
  footer: {
    padding: '20px 20px',
    backgroundColor: colors.onahau,
    width: '100%',
    position: 'sticky',
    bottom: 0,
  },
  image: {
    marginTop: 20,
    marginBottom: 15,
  },
}));

export const DownloadLayout = ({ emission }: Props): JSX.Element => {
  const classes = useStyles();

  const { onRequestDownloadPdf, requestStatus } = useDownloadPolicy(emission);

  return (
    <Box className={classes.container} data-testid="download-layout-container">
      <Box className={classes.content}>
        <Box display="flex" flexDirection="column" alignItems="center">
          <SubTitle2Text>¡Listo!</SubTitle2Text>
          <img
            className={classes.image}
            src="/svg/activation_success.svg"
            alt="modification success"
            data-testid="download-layout-image"
          />
          <SubTitle3Text>tu póliza ha sido actualizada. Pronto</SubTitle3Text>
          <SubTitle3Text>estarás recibiendo un correo con la</SubTitle3Text>
          <SubTitle3Text>póliza</SubTitle3Text>
        </Box>
      </Box>

      <Box className={classes.footer}>
        <DefaultButton
          id="vin-modification-download"
          fullWidth
          data-testid="vin-modification-download"
          onClick={onRequestDownloadPdf}
          disabled={requestStatus === 'requesting'}
        >
          {requestStatus === 'requesting' ? (
            <CircularProgress data-testid="network-ind-pdf" size={20} />
          ) : (
            'Descargar póliza'
          )}
        </DefaultButton>
      </Box>
    </Box>
  );
};

export const mapStateToProps = (
  state: RootState,
): {
  emission: EmissionResume;
} => ({
  emission: state.emission.emission,
});

const connector = connect(mapStateToProps, {});
type Props = ConnectedProps<typeof connector>;

export default connector(DownloadLayout);
